/**
 * @license
 * Copyright 2020 Google Inc.
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * @internal
 */
export const paperFormats = {
    letter: { width: 8.5, height: 11 },
    legal: { width: 8.5, height: 14 },
    tabloid: { width: 11, height: 17 },
    ledger: { width: 17, height: 11 },
    a0: { width: 33.1102, height: 46.811 },
    a1: { width: 23.3858, height: 33.1102 },
    a2: { width: 16.5354, height: 23.3858 },
    a3: { width: 11.6929, height: 16.5354 },
    a4: { width: 8.2677, height: 11.6929 },
    a5: { width: 5.8268, height: 8.2677 },
    a6: { width: 4.1339, height: 5.8268 },
};
//# sourceMappingURL=PDFOptions.js.map